import { useEffect, useState } from 'react';
import { THEME_EVENT, getDensity, getThemeMode, resolveTheme } from '../utils/theme';

// Reactive view of the UI preferences (theme mode / resolved theme /
// density). Re-renders on every change dispatched by utils/theme.js.
export default function useUiPrefs() {
  const [state, setState] = useState(() => ({
    mode: getThemeMode(),
    resolved: resolveTheme(),
    density: getDensity(),
  }));
  useEffect(() => {
    const sync = () => setState({ mode: getThemeMode(), resolved: resolveTheme(), density: getDensity() });
    window.addEventListener(THEME_EVENT, sync);
    return () => window.removeEventListener(THEME_EVENT, sync);
  }, []);
  return state;
}
